import React from 'react'

import {FilterBarDashboard} from '../FilterBarDasboard'
import { FilterIcon } from '@heroicons/react/solid'
import { FilterIcon as FilterIconOutline } from '@heroicons/react/outline'
import {typeDProductsFilters} from '../../dataProducts/filters'
import {Button} from 'components/UI/Button/Button'
import { Trans } from '@lingui/macro'
import { typeInputSearch} from 'components/UI/InputSearch/InputSearch'


// Type
export type typeFiltersDashboard = {
    variant?: string
    searchBar?: React.ReactElement<typeInputSearch>
    filters?: {
        openFilterBar: boolean,
        setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>,
        filtersForm: React.ReactElement<typeDProductsFilters>,
        filterBadges?: any,
    }
    isActiveFilters?: boolean,
}

// Component
export const FiltersDashboard: React.FC<typeFiltersDashboard> = ({ filters, searchBar, isActiveFilters}) => {
    return(
        <>
            <div className="flex flex-col gap-y-2">
                <div className="flex gap-4 justify-between">

                    <div className="flex-grow">
                        {searchBar}
                    </div>

                    {filters
                        ? <Button type="button"
                                  icon={ isActiveFilters ?<FilterIcon className="h-5 w-5 mr-2 "/>: <FilterIconOutline className="h-5 w-5 mr-2 "/>}
                                  label={<Trans>Filters</Trans>}
                                  onClick={() => filters.setOpenFilterBar(true)}/>
                        : null
                    }

                </div>
                {filters
                    ? <div>
                        {/* badges */}
                    </div>
                    : null
                }

            </div>
            {filters
                ? <FilterBarDashboard filtersForm={filters.filtersForm} openFilterBar={filters.openFilterBar} setOpenFilterBar={filters.setOpenFilterBar}/>
                : null
            }
        </>
    )
}
